<div class="innerBanner">
    <div class="container md">
        <div class="viewerAssign">
            <div class="row">
                <div class="col-12 col-md-6">
                   <div class="">
                       <a href="javascript:void(0);" class="backLink" [routerLink]="['/assigned_details_resume']"
                       [queryParams]="{courseId:course_id}"><b><img src="assets/images/icons/backarrow.png" /></b>BACK  TO COURSE DETAILS</a>
                   </div>
                   <div class="viewerModule">
                       <h2 >{{moduleName}}</h2>
                       <div class="engineWrap">
                       <!-- <div class="joinerDetails mb-0">
                           <span class="joinerDetailsImage">
                               <img src="assets/images/icons/doughnut_chart.svg">
                            </span>
                            <div class="joinerContent">
                                <h3>15%</h3>
                                <div class="ghrapWrap mb-0">
                                    <span style="width: 15%;"></span>
                                </div>
                            </div>
                        </div> -->
                    </div>
                    </div>
                    <div class="viewerSubModule">
                        <div class="viewerSubTitle">
                            <span *ngIf="getModulSubData">{{getModulSubData.submodule_name}}</span>
                            <h2 *ngIf="getModulSubData">{{getModulSubData.submodule_desc}}</h2>
                        </div>
                        <div class="viewerModifyi">
                            <ul class="modifyIcons">
                                <li>
                                    <a href="javascript:void(0);"><img src="assets/images/icons/frame.svg" /></a>
                                </li>
                                <!-- <li>
                                    <a href="javascript:void(0);"><img src="assets/images/icons/text.svg" /></a>
                                </li>
                                <li>
                                    <a href="javascript:void(0);"><img src="assets/images/icons/insert-picture.svg" /></a>
                                </li>
                                <li>
                                    <a href="javascript:void(0);"><img src="assets/images/icons/video-camera.svg" /></a>
                                </li> -->
                            </ul>
                        </div>
                    </div>
                     
                </div>
                <div class="col-12 col-md-6">
                    <div class="timerWrap">
                        <ul>
                            <li>
                                <div class="timer">
                                    <span>00</span>
                                    <small>hrs</small>
                                </div>
                            </li>
                            <li>
                                <b>:</b>
                            </li>
                            <li>
                                <div class="timer">
                                    <span>00</span>
                                    <small>min</small>
                                </div>
                            </li>
                            <li>
                                <b>:</b>
                            </li>
                            <li>
                                <div class="timer">
                                    <span>00</span>
                                    <small>sec</small>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
 <div class="dynamicBookWrap mt-4 mb-4">
<div class="container">
    <div class="row">
        <div class="dynamicPlugin">
<div class="demo_ddd pt-3 pb-3">
    <p [innerHtml]='assData?.assessment_instruction'></p>
<div class="detailViewer">
    <div class="joinerDetails">
        <span class="joinerDetailsImage">
            <img src="assets/images/icons/questionMark.png"></span>
            <div class="joinerContent">
                <h3>{{assData?.total_questions}}</h3>
                <p>No. of Questions</p>
            </div>
        </div>
        <div class="joinerDetails">
            <span class="joinerDetailsImage">
            <img src="assets/images/icons/time.svg"></span>
            <div class="joinerContent">
                <h3>{{assData?.assest_time_hr}} hrs {{assData?.assest_time_min}} min</h3>
                <p>Time limit for assessment</p>
            </div>
        </div>
</div>
<ngx-spinner>
    <p style="color: white"> Loading... </p>
</ngx-spinner>
<div class="text-center mt-4">
    <button class="btn btn-primary" style="padding: 0 15px; line-height: 34px;" *ngIf="assData?.assessment_id !=''" (click)="startAssessments()">Start Assessment</button>
</div>
        </div>
    </div>
    </div>
</div>
<input type="hidden" (click)="open1(multiloginValidation)" id="successMsg">
 </div>
 <ng-template #multiloginValidation let-modal>
    <div class="modal-body">
        <div class="holdPopup text-center">
            <button type="button" class="close" aria-label="Close" (click)="navigationEvent();modal.dismiss('Cross click')">
                <span aria-hidden="true">&times;</span>
            </button>
            <div>
                <p class="size18">Please logout from other devices or login again to continue using the portal here</p>
                <input type="hidden" (click)="modal.dismiss('Save click')" id="CloseIds">
                <a href="javascript:void(0);" (click)="navigationEvent();modal.dismiss('Cross click')" class="backPage ml-2 mr-2">OK</a>
            </div>
        </div>
    </div>
</ng-template>
